import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class MbillServiceClassRateService {
  mbillServiceClassRate: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'mbill_service_class_rate/list/?';
  private ByServiceandclass = webapi + 'mbill_service_class_rate/byidServiceandclass/?';
  private ByService = webapi + 'mbill_service_class_rate/byidService/?';
  private AddRecord = webapi + 'mbill_service_class_rate/create';
  private EditRecord = webapi + 'mbill_service_class_rate/update';
  private GetRecord = webapi + 'mbill_service_class_rate/byid/';
  private DeleteRecord = webapi + 'mbill_service_class_rate/delete/';

  constructor(private http: Http) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getByServiceandclass(serviceId: any, classId: any) {
    return this.http.get(this.ByServiceandclass + 'scrServiceId=' + serviceId + '&scrClassId=' + classId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllByService(serviceId: any) {
    return this.http.get(this.ByService + 'serviceId=' + serviceId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mbill-service-class-rate/mbill-service-class-rate.service.ts